import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Hur många rätt krävs på kunskapsprovet?";
const SHORT_ANSWER = "Minst 75% rätt per kunskapsområde – det räcker inte att ha hög total poäng om du missar ett enskilt område.";

export const Route = createFileRoute("/fraga/hur-manga-ratt-kravs")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Hur många rätt krävs på kunskapsprovet" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Provet är uppdelat i flera kunskapsområden (alkohollag, servering, ordning, marknadsföring, tillsyn m.fl.). Du måste klara godkäntgränsen i varje område, inte bara totalt. Det är därför många faller på 'enkla' områden de inte pluggat."}
      source={{ label: "FoHMFS 2014:7 – Föreskrifter om kunskapsprov", href: "https://www.folkhalsomyndigheten.se/publikationer-och-material/publikationsarkiv/f/fohmfs-20147/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/hur-manga-ratt-kunskapsprovet", label: "Hur många rätt krävs på kunskapsprovet" }}
      related={[{"to": "/fraga/hur-lang-tid-tar-provet", "label": "Hur lång tid har jag på mig på kunskapsprovet?"}, {"to": "/fraga/far-jag-anvanda-lagboken", "label": "Får jag använda lagboken på kunskapsprovet?"}, {"to": "/fraga/hur-manga-fragor-har-provet", "label": "Hur många frågor har kunskapsprovet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Hur många rätt krävs på kunskapsprovet?" },
      { name: "description", content: "Minst 75% rätt per kunskapsområde – det räcker inte att ha hög total poäng om du missar ett enskilt område." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/hur-manga-ratt-kravs" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/hur-manga-ratt-kravs" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/hur-manga-ratt-kravs",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Hur många rätt krävs på kunskapsprovet", url: "https://alkoholprovet.se/fraga/hur-manga-ratt-kravs" },
      ]),
    ],
  }),
});
